document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('h2').forEach(function(el) {
    var li = el.parentNode;
    li.insertAdjacentHTML('afterend', '<h2>' + el.textContent + '</h2>');
    li.removeChild(el);
  });

});
